import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { Burger } from './Burger';
import React from 'react';
export var Sling = function Sling(props) {
  return /*#__PURE__*/React.createElement(Burger, _extends({}, props, {
    render: function render(o) {
      return /*#__PURE__*/React.createElement("div", {
        className: "hamburger-react",
        "aria-label": o.label,
        onClick: o.handler,
        onKeyUp: function onKeyUp(e) {
          return e.key === 'Enter' && o.handler();
        },
        role: "button",
        style: _objectSpread(_objectSpread({}, o.burgerStyles), {}, {
          transform: "".concat(o.isToggled ? "rotateY(".concat(180 * (o.isLeft ? -1 : 1), "deg)") : 'none')
        }),
        tabIndex: 0
      }, /*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({}, o.barStyles), {}, {
          width: "".concat(o.width, "px"),
          top: "".concat(o.topOffset, "px"),
          transition: "".concat(o.time, "s ").concat(o.easing),
          transform: "".concat(o.isToggled ? "rotate(".concat(45 * (o.isLeft ? -1 : 1), "deg) translate(").concat(o.move * (o.isLeft ? -1 : 1), "px, ").concat(o.move, "px)") : 'none')
        })
      }), /*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({}, o.barStyles), {}, {
          width: "".concat(o.width, "px"),
          top: "".concat(o.topOffset + o.barHeight + o.margin, "px"),
          transition: "".concat(o.time, "s ").concat(o.easing),
          transform: "".concat(o.isToggled ? "scale(0, 1) translate(".concat(o.move * 20 * (o.isLeft ? -1 : 1), "px, 0)") : 'none')
        })
      }), /*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({}, o.barStyles), {}, {
          width: "".concat(o.width, "px"),
          top: "".concat(o.topOffset + o.barHeight * 2 + o.margin * 2, "px"),
          transition: "".concat(o.time, "s ").concat(o.easing),
          transform: "".concat(o.isToggled ? "rotate(".concat(45 * (o.isLeft ? 1 : -1), "deg) translate(").concat(o.move * (o.isLeft ? -1 : 1), "px, ").concat(o.move * -1, "px)") : 'none')
        })
      }));
    }
  }));
};